import { render, staticRenderFns } from "./ServiceComponent.vue?vue&type=template&id=44f87248&scoped=true"
import script from "./ServiceComponent.vue?vue&type=script&lang=js"
export * from "./ServiceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f87248",
  null
  
)

export default component.exports